module.exports = __webpack_public_path__ + "img/matt.f6341511.jpg";